import { FC, memo } from 'react'
import styled, { css } from 'styled-components'

export type TDrawCategoryGroupInfo = {
  id: string
  name: string
  isActive: boolean
  isSelect: boolean
}

interface IFDrawCategoryGroupProps {
  categoryGroup: TDrawCategoryGroupInfo
  hasChildren?: boolean
  onClick: (DrawCategoryGroupId: string) => void
  className?: string
}

const DrawCategoryGroup: FC<IFDrawCategoryGroupProps> = ({
  categoryGroup,
  hasChildren = false,
  onClick,
  className,
}) => {
  const { id, name, isActive, isSelect } = categoryGroup

  const handleClick = () => {
    onClick(id)
  }

  return (
    <StyledWrapper
      onClick={handleClick}
      data-is-active={isActive}
      data-is-select={isSelect}
      className={className}
    >
      <div className="group-content">
        <span>{name}</span>
        {/* TODO 아이콘으로 변경 */}
        {hasChildren && '>'}
      </div>
    </StyledWrapper>
  )
}

export default memo(DrawCategoryGroup, (prev, next) => {
  return !(
    prev.categoryGroup.isActive !== next.categoryGroup.isActive ||
    prev.categoryGroup.isSelect !== next.categoryGroup.isSelect ||
    prev.onClick !== next.onClick
  )
})

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    padding: 0 20px;
    color: ${theme.color.text_2};
    transition: all 0.1s ease-in-out;
    .group-content {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 10px 0;
      font-size: 12px;
      font-weight: 500;
    }

    .arrow-right {
      width: 10px;
      height: 10px;
      color: #bbbbbb;
    }
    &:not(:last-child) {
      .group-content {
        border-bottom: 1px solid ${theme.line.line_3};
      }
    }

    &[data-is-select='true'] {
      color: ${theme.color.primary_2};
    }
    &[data-is-active='true'] {
      background-color: ${theme.background.bg_4};
      color: ${theme.color.primary_2};
      .arrow-right {
        color: ${theme.color.primary_2};
      }
    }
    :hover {
      cursor: pointer;
      background-color: ${theme.background.bg_3};
    }
  `}
`
